const doc = [({"zh_tw":({"adminConstantPromotionType":({"consecutiveStay":"連續住宿折扣", "goto":"去旅行", "member":"會員折扣", "official":"官網限時優惠", "promotionCode":"輸入代碼"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;